import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=4f5e63d4&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=4f5e63d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e63d4",
  null
  
)

export default component.exports